import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";

@Component({
  selector: 'micro-smsCarrier-detail',
  templateUrl: './smsCarrier-detail.component.html'
})
export class SmsCarrierDetailComponent extends BaseComponent {
  smsCarrier:any;
  changePassword:boolean = false;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/sms/carriers/${id}`).subscribe(
            data => {
              this.smsCarrier = data as any;
            }
          );
        }
      });
  }

  createNew() {
    this.smsCarrier = {
      enabled: true
    };
  }

  save() {
    if (!this.smsCarrier.id) {
      this.http.post(`${this.env.e.url}/sms/carriers`, this.smsCarrier)
        .subscribe(
          data => {
            this.smsCarrier = data;
            this.alertService.info(`Created ${this.smsCarrier.name}`);
            this.changePassword = false;
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/sms/carriers/${this.smsCarrier.id}`, this.smsCarrier)
        .subscribe(
          data => {
            this.smsCarrier = data;
            this.alertService.info(`Updated`);
            this.changePassword = false;
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/sms/carriers/${this.smsCarrier.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.smsCarrier.name}`);
          this.router.navigate(["/sms/carriers"]);
        }
      );
  }
}
